import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { LANDING_ENDCAP_ZOOM, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, PREVIOUS_BLOCK_TOP, REVEAL_SPACING, } from "./shared";
/** News completes the family with a subtle counter-clockwise lean, right bias,
 * and narrower silhouette so the three routes remain related but distinct. */
export const NEWS_PRESET = {
    id: "news",
    roles: ["settle"],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    curveProfile: {
        viewportSpan: 0.4,
        xCheckpoints: [0.23, 0.66, 0.47],
        bendWindows: [0.08, 0.4, 0.63, 0.9],
        mobile: { viewportSpan: 0.3, xCheckpoints: [0.24, 0.63, 0.47] },
    },
    initialStateId: "news-hero",
    states: [
        {
            id: "news-hero",
            background: PAPER,
            zoom: 0.84,
            ribbonWidthScale: 0.74,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.39, 0.48],
            rotationDeg: -82,
            lineExtent: 0.44,
            turbulence: 0.26,
            spacing: REVEAL_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.09,
            twistRetention: 0.92,
            fanSpread: 0.016,
            twistSpread: 0.032,
            horizontalStretch: 1.36,
            unravel: 0.5,
            curveStrength: 0.62,
            curveProgress: 0.16,
            mobile: {
                zoom: 0.41,
                center: [0.4, 0.48],
                rotationDeg: -84,
                lineExtent: 0.64,
                ribbonWidthScale: 0.74,
                fanSpread: 0.009,
                twistSpread: 0.02,
                horizontalStretch: 1.15,
                curveStrength: 0.46,
            },
        },
        {
            id: "news-feed",
            background: PAPER,
            zoom: 0.82,
            ribbonWidthScale: 0.72,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.48, 0.49],
            rotationDeg: -89,
            lineExtent: 0.47,
            turbulence: 0.11,
            spacing: LINE_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.03,
            twistRetention: 0.99,
            fanSpread: 0.003,
            twistSpread: 0.007,
            horizontalStretch: 1.03,
            unravel: 0.1,
            curveStrength: 0.08,
            curveProgress: 0.58,
            mobile: {
                zoom: 0.4,
                center: [0.48, 0.49],
                rotationDeg: -89,
                lineExtent: 0.66,
                ribbonWidthScale: 0.72,
                curveStrength: 0.06,
            },
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "news-feed",
            start: PREVIOUS_BLOCK_TOP,
            end: { target: "top", viewport: 0.25 },
        },
    ],
};
//# sourceMappingURL=news.js.map